import React from 'react'
import { Box, Typography, Container } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { TrustpilotReview } from '@talentinc/gatsby-source-trustpilot-widget'
import SvgFiveStars from '../../images/five-stars.inline.svg'
import getColor from '../../utils/colors'
import { BGVariants } from '../../types/heroTextSection'

interface ReviewProps {
  review: TrustpilotReview
  background: BGVariants
}

const ReviewCardName: React.FC<ReviewProps> = ({ review, background }) => {
  const { classes } = useStyles({ background })

  return (
    <Container
      className={classes.containerReviewSmall}
      disableGutters
      itemScope
      itemType="https://schema.org/Review"
    >
      <Box className={classes.cardContentReviewSmall}>
        <Box
          itemProp="reviewRating"
          itemScope
          itemType="https://schema.org/Rating"
        >
          <meta itemProp="worstRating" content="1" />
          <meta itemProp="ratingValue" content={review.stars.toString()} />
          <meta itemProp="bestRating" content="5" />
          <SvgFiveStars alt="Five Stars" className={classes.stars} />
        </Box>
        <meta itemProp="datePublished" content={review.createdAt} />
        <Typography className={classes.title} variant="h4" itemProp="author">
          {review.consumer.displayName}
        </Typography>
        <Typography
          className={classes.text}
          variant={'body2'}
          itemProp="reviewBody"
        >
          {review.text}
        </Typography>
      </Box>
    </Container>
  )
}

const useStyles = makeStyles<{ background: string }>()(
  (theme, { background }) => {
    const backgroundColor = getColor(background, theme)

    return {
      containerReviewSmall: {
        backgroundColor,
        margin: '1.55rem 0',
        width: '93%',
      },
      cardContentReviewSmall: {
        textAlign: 'left',
        padding: '2.625rem 2rem',
      },
      stars: {
        color: theme.colors.orange['a100'],
      },
      title: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding: '1.5625rem 0 .65rem 0',
        width: '90%',
      },
      text: {
        [theme.breakpoints.down('md')]: {
          fontSize: '1rem',
        },
      },
    }
  }
)

export default ReviewCardName
